module.exports = __webpack_public_path__ + "img/img23.fc71c41d.svg";